<template>
  <div class="pro-page">
    <div class="overlay"></div>
    <Header />
    
    <main class="main-content">
      <section class="product-hero">
        <div class="hero-content">
          <h1 class="hero-title" data-aos="fade-up">数据驱动智造<br>协同创造价值</h1>
          <p class="hero-subtitle" data-aos="fade-up" data-aos-delay="200">
            融合高端制造业严谨性与数字化技术未来感<br>
            打造智能制造新生态
          </p>
        </div>
        <div class="hero-background">
          <div class="data-flow"></div>
        </div>
      </section>

      <section id="erp" class="product-section">
        <div class="container">
          <div class="section-header" data-aos="fade-up">
            <h2 class="section-title">一体化ERP：管简单</h2>
            <p class="section-subtitle">全流程数字化管理，让企业管理更简单</p>
          </div>
          
          <div class="erp-cards-grid">
            <div class="erp-card" v-for="(card, index) in erpCards" :key="index" data-aos="zoom-in" :data-aos-delay="(index + 1) * 100">
              <div class="erp-card-image">
                <img :src="require(`@/assets/images/${card.image}`)" :alt="card.title">
                <div class="card-overlay"></div>
              </div>
              <div class="erp-card-content">
                <h3>{{ card.title }}</h3>
                <p>{{ card.description }}</p>
              </div>
            </div>
          </div>
          
<!-- 系统预览部分已删除 -->
        </div>
      </section>

      <section id="mes" class="product-section mes-section">
        <div class="container">
          <div class="section-header" data-aos="fade-up">
            <h2 class="section-title">数字车间MES</h2>
            <p class="section-subtitle">打造智能互联的数字化工厂</p>
          </div>
          
          <div class="mes-platforms">
            <div class="platform-card" v-for="(platform, index) in mesPlatforms" :key="index" data-aos="fade-right">
              <img :src="require(`@/assets/images/${platform.image}`)" :alt="platform.title">
              <h3>{{ platform.title }}</h3>
              <p>{{ platform.description }}</p>
              <div class="platform-features">
                <span v-for="feature in platform.features" :key="feature">{{ feature }}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="marketing" class="product-section marketing-section">
        <div class="container">
          <div class="section-header" data-aos="fade-up">
            <h2 class="section-title">工业物联网</h2>
            <p class="section-subtitle">信息化系统与自动化系统的高度集成实现现场作业数据的传输与交换，让数据跟实物同步流动，人机协同作业</p>
          </div>
          <div class="marketing-solutions">
            <div class="solution-card" v-for="(solution, index) in marketingSolutions" :key="index" data-aos="flip-left">
              <img :src="require(`@/assets/images/${solution.image}`)" :alt="solution.title">
              <h3>{{ solution.title }}</h3>
              <div class="solution-details">
                <p>{{ solution.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="mobile" class="product-section mobile-section">
        <div class="container">
          <div class="section-header" data-aos="fade-up">
            <h2 class="section-title">移动办公</h2>
            <p class="section-subtitle">随时随地，高效协同</p>
          </div>
          <div class="mobile-features">
            <div class="feature-item" v-for="(feature, index) in mobileFeatures" :key="index" data-aos="fade-right">
              <div class="feature-icon">
                <img :src="require(`@/assets/images/${feature.image}`)" :alt="feature.title">
              </div>
              <h3>{{ feature.title }}</h3>
              <div class="feature-details">
                <ul>
                  <li v-for="detail in feature.details" :key="detail">{{ detail }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="manufacturing" class="product-section manufacturing-section">
        <div class="container">
          <div class="section-header" data-aos="fade-up">
            <h2 class="section-title">智能制造</h2>
            <p class="section-subtitle">引领工业4.0革命</p>
          </div>
          <div class="manufacturing-showcase">
            <div class="showcase-item" v-for="(showcase, index) in manufacturingShowcase" :key="index" data-aos="fade-right">
              <div class="showcase-visual">
                <div class="tech-animation">
                  <img :src="require(`@/assets/images/${showcase.image}`)">
                </div>
              </div>
              <div class="showcase-info">
                <h3>{{ showcase.title }}</h3>
                <p>{{ showcase.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    
    <Footer />
    <SideService />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import SideService from '@/components/SideService.vue';

export default {
  name: 'Pro',
  components: {
    Header,
    Footer,
    SideService
  },
  data() {
    return {
      erpCards: [
        {
          image: 'caigouguanli.png',
          title: '采购管理',
          description: '智能采购决策，供应商全生命周期管理，成本优化与风险控制，实现采购流程数字化转型'
        },
        {
          image: 'cangkuguanli.jpg',
          title: '仓库管理',
          description: '智能库存管控，精准库位管理，实时盘点与预警，打造高效智慧仓储运营体系'
        },
        {
          image: 'shengcanguanli.png',
          title: '生产管理',
          description: '智能排产调度，实时生产监控，质量全程追溯，助力制造企业实现精益生产管理'
        },
        {
          image: 'xiaoshouguanli.png',
          title: '销售管理',
          description: '客户关系深度经营，销售流程智能化管控，数据驱动营销决策，提升销售业绩与客户满意度'
        }
      ],
      mesPlatforms: [
        {
          image: '智能排单.jpg',
          title: '智能排单',
          description: 'AI算法优化生产排程，智能调配资源，提升生产效率与交期准确率',
          features: ['智能算法', '资源优化', '自动排程']
        },
        {
          image: 'znsm.jpg',
          title: '扫码报工',
          description: '移动端扫码快速报工，实时记录工时工序，提升生产数据采集效率',
          features: ['移动报工', '实时记录', '数据采集']
        },
        {
          image: '进度追踪.jpg',
          title: '进度追踪',
          description: '全流程可视化监控，实时追踪生产进度，精准掌控订单执行状态',
          features: ['可视化监控', '实时追踪', '状态管控']
        }
      ],
      marketingSolutions: [
        {
          image: 'wulianwang1.jpg',
          title: '车间设备互联互通',
          description: '实现智能传感器、控制器、变频器、在线检测设备的高度集成，建立车间级工业互联网，实现所有设备互联'
        },
        {
          image: 'wulianwang2.jpg',
          title: '生产过程实时透明',
          description: '从原材料到成品，全过程实现自动化监控，故障自动报警诊断，所有数据同步传给ERP，助力经营决策'
        },
        {
          image: 'wulianwang3.jpg',
          title: '工艺改造全程追溯',
          description: '实现智能传感器、控制器、变频器、在线检测设备的高度集成，建立车间级工业互联网，实现所有设备互联'
        }
      ],
      mobileFeatures: [
        {
          image: 'yidong1.jpg',
          title: '移动审批',
          details: ['随时随地处理审批', '多级审批流程', '审批进度实时追踪']
        },
        {
          image: 'yidong2.jpg',
          title: '任务协同',
          details: ['任务分配与跟进', '团队实时协作', '进度监控与提醒']
        },
        {
          image: 'yidong3.jpg',
          title: '数据报表',
          details: ['实时业务数据', '可视化图表展示', '多维度数据分析']
        }
      ],
      manufacturingShowcase: [
        {
          image: 'znzz1.gif',
          title: '智工系列',
          description: '智能识别、精准包装、质量控制'
        },
        {
          image: 'znzz2.gif',
          title: '智工贴系列',
          description: '机器人作业、智能调度、安全防护'
        },
        {
          image: 'znzz3.gif',
          title: '智慧物流',
          description: '路径优化、避障导航、集群调度'
        }
      ]
    }
  },
  mounted() {
    // 初始化AOS动画库
    if (typeof AOS !== 'undefined') {
      AOS.init({
        duration: 1000,
        once: true
      });
    }
  }
}
</script>

<style scoped>
/* 产品Hero区域 */
.product-hero {
  position: relative;
  height: 100vh;
  min-height: 800px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #009b7b 0%, #006d56 100%);
  color: white;
  overflow: hidden;
}

.hero-content {
  position: relative;
  z-index: 2;
  text-align: center;
}

.hero-title {
  font-size: 3.5rem;
  margin-bottom: 2rem;
  line-height: 1.2;
}

.hero-subtitle {
  font-size: 1.3rem;
  line-height: 1.8;
  opacity: 0.9;
}

.hero-background {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow: hidden;
}

.data-flow {
  width: 100%;
  height: 100%;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000"><defs><linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" style="stop-color:rgba(255,255,255,0.1);stop-opacity:1" /><stop offset="100%" style="stop-color:rgba(255,255,255,0);stop-opacity:1" /></linearGradient></defs><circle cx="500" cy="500" r="400" fill="none" stroke="url(%23grad)" stroke-width="2"/></svg>');
  animation: rotate 20s linear infinite;
}

.data-flow::before,
.data-flow::after {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 50%;
}

.data-flow::before {
  top: 20%;
  left: 20%;
  animation: pulse 2s infinite;
}

.data-flow::after {
  bottom: 30%;
  right: 25%;
  animation: pulse 2s infinite 1s;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.5);
    opacity: 0.7;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* 产品区域 */
.product-section {
  padding: 5rem 0;
}

.section-header {
  text-align: center;
  margin-bottom: 4rem;
}

.section-title {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: #333;
}

.section-subtitle {
  font-size: 1.2rem;
  color: #666;
  line-height: 1.6;
}

/* ERP卡片 */
.erp-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  margin-bottom: 4rem;
}

.erp-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  cursor: pointer;
}

.erp-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.erp-card-image {
  position: relative;
  height: 200px;
  overflow: hidden;
}

.erp-card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.erp-card:hover .erp-card-image img {
  transform: scale(1.1);
}

.card-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.3));
}

.erp-card-content {
  padding: 1.5rem;
}

.erp-card-content h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #333;
}

.erp-card-content p {
  color: #666;
  line-height: 1.6;
}

/* 系统预览 */
.system-preview {
  margin-top: 4rem;
}

.preview-screen {
  background: #f5f5f5;
  border-radius: 12px;
  padding: 2rem;
  min-height: 400px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

/* MES区域 */
.mes-section {
  background: #f8f9fa;
}

.mes-platforms {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.platform-card {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  text-align: center;
}

.platform-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.platform-card img {
  width: 100%;
  max-height: 200px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 1.5rem;
}

.platform-card h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #333;
}

.platform-card p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.platform-features {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  justify-content: center;
}

.platform-features span {
  background: #e3f2fd;
  color: #1976d2;
  padding: 0.3rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
}

/* 营销区域 */
.marketing-section {
  background: white;
}

.marketing-solutions {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.solution-card {
  background: white;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  padding: 2rem;
  transition: all 0.3s;
}

.solution-card:hover {
  border-color: #007bff;
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.2);
}

.solution-card img {
  width: 100%;
  border-radius: 8px;
  margin-bottom: 1.5rem;
}

.solution-card h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #333;
}

.solution-details p {
  color: #666;
  line-height: 1.8;
}

/* 移动办公区域 */
.mobile-section {
  background: #f8f9fa;
}

.mobile-features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.feature-item {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 155, 123, 0.2);
}

.feature-icon img {
  width: 100%;
  border-radius: 8px;
  margin-bottom: 1.5rem;
}

.feature-item h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #333;
}

.feature-details ul {
  list-style: none;
  padding: 0;
}

.feature-details li {
  padding: 0.5rem 0;
  color: #666;
  padding-left: 1.5rem;
  position: relative;
}

.feature-details li::before {
  content: "✓";
  position: absolute;
  left: 0;
  color: #007bff;
  font-weight: bold;
}

/* 智能制造区域 */
.manufacturing-section {
  background: white;
}

.manufacturing-showcase {
  display: flex;
  justify-content: space-between;
  gap: 2rem;
}

.showcase-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 2rem;
  transition: all 0.3s ease;
}

.showcase-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 155, 123, 0.2);
}

.showcase-visual {
  //background: #f5f5f5;
  border-radius: 12px;
  //padding: 2rem;
  margin-bottom: 1.5rem;
}

.tech-animation img {
  width: 100%;
  border-radius: 8px;
}

.showcase-info h3 {
  font-size: 1.8rem;
  margin-bottom: 1rem;
  color: var(--primary-color);
}

.showcase-info p {
  color: #666;
  line-height: 1.6;
  font-size: 1rem;
}

/* 响应式设计 */
@media (max-width: 992px) {
  .hero-title {
    font-size: 2.5rem;
  }

  .showcase-item {
    grid-template-columns: 1fr;
  }

  .showcase-item:nth-child(even) {
    direction: ltr;
  }
}

@media (max-width: 768px) {
  .product-hero {
    height: 400px;
  }

  .hero-title {
    font-size: 2rem;
  }

  .hero-subtitle {
    font-size: 1rem;
  }

  .section-title {
    font-size: 2rem;
  }

  .erp-cards-grid,
  .mes-platforms,
  .marketing-solutions,
  .mobile-features {
    grid-template-columns: 1fr;
  }
}
</style>